import { readHostingConfiguration } from '@ms/yammer-web-support/dist/hosting';

__webpack_public_path__ = readHostingConfiguration().scriptBaseUrl || '/';

import { loadPolyfills } from '../2-polyfill';

import { bootstrapApp } from './bootstrap';

(async () => {
  await loadPolyfills();
  await bootstrapApp();
})();
